module.exports = __webpack_public_path__ + "img/mobilenewsLogo5.38e2f572.png";